const BACKOFFICE_RISK = {
  ADD_COMPANIES_TO_BLACKLIST: 'backoffice_risk.add_riskblacklist',
};

const BUREAUS = {
  VIEW_DICOM: 'bureaus.view_dicom',
};

const COMMERCIAL = {
  VIEW_CUSTOMERS_PORTFOLIO: 'auth.view_commercial_customers_portfolio',
  VIEW_PIPELINE_MANAGER: 'auth.view_commercial_pipeline_manager',
  VIEW_CESSION_PREDICTIONS: 'auth.view_commercial_cession_predictions',
  EXPORT_CUSTOMERS_PORTFOLIO: 'auth.export_commercial_customers_portfolio',
  EXPORT_CESSION_PREDICTIONS: 'auth.export_commercial_cession_predictions',
};

const CUSTOMERS = {
  ADD_COMPANYFRAMEWORKCONTRACTREQUEST: 'customers.add_companyframeworkcontractrequest',
  ADD_COMPANYFRAMEWORKCONTRACTREGISTER: 'customers.add_companyframeworkcontractregister',
  ADD_COMPANY_RESTRICTION: 'customers.add_companyevaluationrestrictions',
};

const EVALUATION_REQUESTS = {
  CAN_SKIP_PREOFFER_ASSIGNED_EVALUATOR_VALIDATION: 'evaluation_requests.can_skip_preoffer_assigned_evaluator_validation',
  CHANGE_PREOFFER_EVALUATION_REQUEST: 'evaluation_requests.change_preofferevaluationrequest',
  CHANGE_CREDITLINE_EVALUATION_REQUEST: 'evaluation_requests.change_creditlineevaluationrequest',
};

export {
  BACKOFFICE_RISK,
  BUREAUS,
  COMMERCIAL,
  CUSTOMERS,
  EVALUATION_REQUESTS,
};
